import React from 'react';
import { PropTypes } from 'prop-types';
import { Form } from 'react-bootstrap';
import { capitalizeFirstLetter } from '../../../../../utils/api/index';

const Header = ({ item, labelClass = '' }) => {
  const label = capitalizeFirstLetter(item.label);

  return (
    <Form.Group className="my-2" controlId={item.key}>
      <Form.Label className={`${labelClass} h5`}>{ label }</Form.Label>
    </Form.Group>
  );
};

Header.propTypes = {
  item: PropTypes.object.isRequired,
  labelClass: PropTypes.string,
};

export default Header;
